"use strict";
import AOS from "aos";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";
import mobileMenu from "./scripts/menu/mobileMenu";
import headerScrolling from "./scripts/headerScrolling";
import infiniteCarrosel from "./scripts/infiniteCarrosel";
import productSlider from "./scripts/productSlider";
import cultureSlider from "./scripts/cultureSlider";
import eventSlider from "./scripts/eventSlider";
import testimonialsSlider from "./scripts/testimonialsSlider";
import aboutSlider from "./scripts/aboutSlider";
import gallerySlider from "./scripts/gallerySlider";

AOS.init({
    once: true,
});

mobileMenu();
headerScrolling();
infiniteCarrosel();
productSlider();
cultureSlider();
eventSlider();
testimonialsSlider();
aboutSlider();
gallerySlider();
